import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/compositor.css';
// Must follow compositor.css: the Atomizer block overrides its tokens.
import './styles/brands.css';
// Must follow brands.css: Ink is the shared signed-in system (src/styles/INK.md).
import './styles/ink.css';
import './styles/ink-flow.css';
import App from './App';
//import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find the root element');
}

// The website is the signed-in app only; public sites are served by the
// tinycms renderer (smagent-sites).
//
// Resolve the saved appearance BEFORE React mounts, otherwise the first paint
// uses the wrong palette and the app visibly flashes when ThemeProvider
// catches up. ThemeProvider owns the attribute from here on; this must stay in
// step with it (src/context/ThemeContext.tsx).
const saved = localStorage.getItem('smagent.theme');
const preference = saved === 'light' || saved === 'dark' ? saved : 'system';
const resolved =
  preference === 'system'
    ? window.matchMedia?.('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : 'light'
    : preference;
document.documentElement.setAttribute('data-theme', resolved);

// The app only routes under /account (package.json "homepage"). On an app host
// (app.tinycms.ai) any other path — most often the bare "/" — would mount the
// router outside its basename and render a blank page, so send it to /account.
// A Cloudflare redirect may do the same at the edge; this is the fallback.
const outsideApp = !window.location.pathname.startsWith('/account');
if (outsideApp) {
  window.location.replace(`/account${window.location.search}${window.location.hash}`);
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
//reportWebVitals();
